export var getPreviousStartDate = function getPreviousStartDate(date, isUserOnMobile) {
  return date.clone().subtract(isUserOnMobile ? 1 : 4, 'month');
};